import { trpc } from '@/shared/api';

export const usePortfolioCategoriesQuery = () =>
  trpc.portfolioManagement.categories.list.useQuery();
